"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormHelperText2 = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var FormHelperText = /*#__PURE__*/(0, _react.forwardRef)(function FormHelperText(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_FormHelperText2.default, Object.assign({}, props, {
    ref: ref
  }));
});
FormHelperText.propTypes = {
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: _propTypes.default.node,

  /**
   *  The CSS class name added to the root of the component.
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _propTypes.default.bool
};
var _default = FormHelperText;
exports.default = _default;
